<script setup>
import {onMounted, ref, reactive, nextTick} from "vue";
import YTTablePagination from "@/components/YTTablePagination/YTTablePagination.vue";
import moment from "moment";
import {listClubCompetition, updateClubCompetition} from "@/api/club/club.js";
import { certificateTypeEnum } from "@/enum/certificateTypeEnum.js";
import YTCompetitionState from "@/components/YTCompetitionState/index.vue"
import YTOrderState from "@/components/YTOrderState/index.vue"
import YTAddress from "@/components/YTAddress/index.vue";
import {competitionStateEnum} from "@/enum/competitionStateEnum.js";
import {genderEnum} from "@/enum/genderEnum.js";
import { userTokenStore } from "@/store/store.js";
import axios from "axios";
import {editCompetitionState} from "@/api/virtualGoods/virtualGoods.js";
import { listClubCompetitionParticipant, listClubCompetitionOrderInfo } from "@/api/competition/competition.js";
import router from "../../router";

/*初次加载*/
onMounted(async () => {
  await handleSearch()
})

/*搜索功能*/
// 表单数据
const formData = reactive({
  name: null,
  time: [],
  city: null,
  startTime: null,
  endTime: null,
});
// 表单锚点
const ruleFormRef = ref()
// 根据表单搜索信息
const handleSearch = async (mode = "init") => {
  if (mode === 'btnSearch') YTTablePaginationRef.value.resetPage()
  try {
    const param = ref({
      page: YTTablePaginationRef.value.getPage(),
      pageSize: YTTablePaginationRef.value.getPageSize()
    })
    loading.value = true;
    // 处理订单时间、驿站id
    formData.startTime = formData.time[0] ? moment(formData.time[0]).format("YYYY-MM-DD") : null;
    formData.endTime = formData.time[1] ? moment(formData.time[1]).format("YYYY-MM-DD") : null;
    // 搜索实物商品
    const res = await listClubCompetition(param.value, formData);
    console.log(res.list, 'tablelist');
    
    tableData.value = []
    tableData.value = res.list
    total.value = parseInt(res.total)
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 城市选择组件锚点
const YTAddressRef = ref()
// 清空表单内容
const handleReset = () => {
  formData.name = null
  formData.time = []
  formData.city = null
  formData.startTime = null
  formData.endTime = null
  handleSearch('btnSearch')
  YTAddressRef.value.cleanSelect()
}

/*表格数据展示*/
// 翻页组件锚点
const YTTablePaginationRef = ref()
// 翻页信息：总条目数、加载状态
const total = ref(0)
const loading = ref(false)
const headers = ref([
  { title: '赛事状态', key: 'competitionState', nowrap: true },
  { title: '赛事名称', key: 'goodsName', nowrap: true },
  { title: '比赛时间', key: 'time', nowrap: true },
  { title: '城市', key: 'city', nowrap: true },
  { title: '发布状态', key: 'state', nowrap: true },
  { title: '操作', key: 'controls', width: "100px", fixed: true },
])
// 表格数据
const tableData = ref([])
// 翻页
const handleChangePage = () => {
  handleSearch()
}
// 展示详情
const isShowDetail = ref(false)
// 详情缓存信息
const detailCache = ref({
  goodsName: null,
  goodsId: null
})
// 详情加载状态
const detailLoading = ref(false)
// 详情表格数据
const detailTableData = ref([])
// 详情翻页锚点
const YTTablePaginationDetailRef = ref()
// 详情支付时间
const detailPayTime = ref([])

// 处理详情页时间选择器改变
const handleChangeDetailPayTime = async (e) => {
  await getDetail(detailCache.value)
}

// 详情页选项卡
const tab = ref('signedUp')
// 详情页配套服务订单合并数据
const detailSpanArr = ref([])
const handleTabChange = async (e) => {
  console.log("handleTabChange", e);
  await getDetail(detailCache.value)
}

// 详情页表格合并单元格
const detailObjectSpanMethod = ({
  row,
  column,
  rowIndex,
  columnIndex,
}) => {
  if (columnIndex <= 6 || columnIndex > 13) {
    const _row = detailSpanArr.value[rowIndex]
    const _col = detailSpanArr.value[rowIndex] > 0 ? 1 : 0
    return [_row, _col]
  }
}

// 处理配套订单返回数据
const flatOrderList = (data) => {
  let result = []
  result = data.reduce((prev, curr) => {
    if(curr.comboInfos.length === 0) {
      prev.push({
        ...curr,
      })
      return prev
    } else {
      curr.comboInfos.forEach(item => {
        prev.push({
          ...curr,
          ...item,
        })
      })
    }
    return prev
  }, [])
  return result
}

// 获取配套服务订单合并数据
const spanOrderList = (data) => {
  let spanArr = []
  let pos = 0
  data.forEach((item, index) => {
    if(index === 0) {
      spanArr.push(1)
      pos = 0
    } else {
      if(item.orderNo === data[index - 1].orderNo) {
        spanArr[pos] += 1
        spanArr.push(0)
      } else {
        spanArr.push(1)
        pos = index
      }
    }
  })
  return spanArr
}

// 赛事状态
const competitionState = ref()
// 赛事状态枚举
const competitionStateOption = ref(competitionStateEnum)
// 处理赛事状态改变
const handleChangeState = async (state) => {
  console.log("state", state)
  await ElMessageBox.confirm(
      '确定修改赛事状态?',
      '警告',
      {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }
  )
      .then(async () => {
        console.log("确定修改赛事状态，即将发起接口")
        competitionState.value = state
        let param = {
          goodsId: detailCache.value.goodsId,
          competitionState: competitionState.value
        }
        console.log("param", param)
        await editCompetitionState(param)
        // TODO 因为没有详情接口，所以暂时不重新请求
        // await getDetail({goodsId: param.goodsId})
        ElMessage({
          type: 'success',
          message: '修改成功',
        })
      })
      .catch(async () => {
        console.log("取消修改赛事状态")
        await getDetail(detailCache.value)
        ElMessage({
          type: 'info',
          message: '取消修改',
        })
      })
}

// 处理下载赛事报名人员名单
const handleDownloadCompetitionUser = () => {
  downloadFile(
    `${
      import.meta.env.VITE_API_URL
    }/competition/order/admin/download/participant?goodsId=${
      detailCache.value.goodsId
    }`,
    {}, // 请求体数据
    `${detailCache.value.goodsName}报名人员名单-${moment().format(
      "YYYY-MM-DD_HHmmss"
    )}.csv` // 默认文件名
  );
}

// 处理下载赛事订单信息
const handleDownloadCompetitionOrder = () => {
  downloadFile(
    `${
      import.meta.env.VITE_API_URL
    }/competition/order/admin/download/supplementaryService?goodsId=${detailCache.value.goodsId}&paymentStartTime=${detailPayTime.value[0] || ''}&paymentEndTime=${detailPayTime.value[1] || ''}`,
    {}, // 请求体数据
    `${detailCache.value.goodsName}配套服务订单信息-${moment().format(
      "YYYY-MM-DD_HHmmss"
    )}.csv` // 默认文件名
  );
}

/**
 * 自定义文件名的下载函数
 * @param {string} url - 完整接口URL
 * @param {Object} requestData - 请求体数据
 * @param {string} customFilename - 自定义文件名
 */
const downloadFile = async (url, requestData = {}, customFilename) => {
  try {
    const token = userTokenStore().token;
    const response = await axios.post(url, requestData, {
      responseType: "blob",
      headers: {
        Authorization: token.tokenValue,
        "Login-Type": token.loginType,
        "Content-Type": "application/json",
      },
      validateStatus: (status) => {
        if(status === 409) {
          ElMessage.error("数据列表为空,暂无数据导出")
          return false
        } else {
          return true
        }
      },
    })

    // 创建下载链接
    const blob = new Blob([response.data]);
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.setAttribute("download", customFilename); // 使用传入的自定义文件名
    document.body.appendChild(link);
    link.click();

    // 清理
    setTimeout(() => {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
    }, 100);

    return true;
  } catch (error) {
    console.error("文件下载失败:", error);
    ElMessage.error("文件下载失败");
    return false;
  }
};

// 获取赛事详情
const getDetail = async (item) => {
  try {
    console.log("getDetail", item)
    isShowDetail.value = true
    detailLoading.value = true
    detailCache.value = item
    competitionState.value = detailCache.value.competitionState
    detailLoading.value = false
    await handleGetParticipantList()
  } catch (e) {
    console.log(e)
    detailLoading.value = false
  }
}
// 返回
const handleBack = () => {
  isShowDetail.value = false
  detailCache.value = {
    goodsName: null
  }
  tab.value = 'signedUp'
  competitionState.value = null
}
// 表格加载状态
const detailTableLoading = ref(false)
// 证件类型枚举
const certificateType = ref(certificateTypeEnum);

// 处理获取赛事详情报名人员列表
const handleGetParticipantList = async () => {
  // 组件弹出需要时间，所以使用nextTick
  await nextTick(async () => {
    try {
      detailTableLoading.value = true
      let pageInfo = {
        page: YTTablePaginationDetailRef.value.getPage(),
        pageSize: YTTablePaginationDetailRef.value.getPageSize()
      }
      const res = tab.value === 'signedUp' ? await listClubCompetitionParticipant(pageInfo, detailCache.value.goodsId) : await listClubCompetitionOrderInfo(pageInfo, detailCache.value.goodsId, detailPayTime.value[0] || '', detailPayTime.value[1] || '')
      detailTableData.value = []
      setTimeout(() => {
        detailTableData.value = tab.value === 'signedUp' ? res.list : flatOrderList(res.list)
        detailSpanArr.value = tab.value === 'signedUp' ? [] : spanOrderList(detailTableData.value)
        if(tab.value === 'signedUp') {
          detailCache.value.registeredCount = res.total
        }
        totalDetail.value = parseInt(res.total)
        detailTableLoading.value = false
      }, 0)
    } catch (e) {
      console.log(e)
      detailTableLoading.value = false
    }
  })
}
// 详情页列表总数
const totalDetail = ref(0)
// 处理详情页翻页
const handleChangeDetailPage = () => {
  handleGetParticipantList()
}

/*操作栏功能*/
// 发布赛事
const setSale = async (item) => {
  const param = {
    goodsId: item.goodsId,
    state: 1
  }
  try {
    await updateClubCompetition(param)
    ElMessage.success("发布成功")
    await handleSearch()
  } catch (e) {
    console.log(e)
  }
}
// 撤销赛事
const setUnSale = async (item) => {
  const param = {
    goodsId: item.goodsId,
    state: 0
  }
  try {
    await updateClubCompetition(param)
    ElMessage.success("撤销成功")
    await handleSearch()
  } catch (e) {
    console.log(e)
  }
}
// 跳转周边订单
const toSurroundingOrder = (item) => {
  console.log("item:", item)
  router.push({path: '/listMerchandiseOrder', query: {competitionGoodsId: item.goodsId, competitionGoodsName: item.goodsName}})
}

// 处理选择所属区域
const handleSelectAddress = (data) => {
  console.log("data:", data)
  formData.city = data.label[data.label.length - 1]
}
</script>

<template>
  <template v-if="!isShowDetail">
    <div class="container_box mg_b_2" style="padding-bottom: 0">
      <el-form
          ref="ruleFormRef"
          style="max-width: 400px;text-align: left"
          :model="formData"
          label-width="auto"
          class="demo-ruleForm"
          status-icon
          label-position="top"
      >
        <el-form-item label="赛事名称：" prop="name">
          <el-input v-model="formData.name" placeholder="请输入赛事名称"></el-input>
        </el-form-item>
        <el-form-item label="比赛时间：" prop="time">
          <el-date-picker
              v-model="formData.time"
              type="daterange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
          />
        </el-form-item>
        <el-form-item label="城市：" prop="city">
          <div style="width: 350px">
            <YTAddress ref="YTAddressRef" :title="'城市'" :onlySecond="true" @select="handleSelectAddress"></YTAddress>
          </div>
        </el-form-item>
      </el-form>
      <v-col cols="3">
        <v-row justify="start">
          <v-col class="flex_left" cols="6">
            <v-btn color="success" size="large" @click="handleSearch('btnSearch')" :disabled="!$handleHasBtnPermission('all', 'competition:view')">搜索</v-btn>
          </v-col>
          <v-col class="flex_left" cols="6">
            <v-btn size="large" @click="handleReset" :disabled="!$handleHasBtnPermission('all', 'competition:view')">重置</v-btn>
          </v-col>
        </v-row>
      </v-col>
    </div>
    <div class="container_box">
      <v-row justify="center">
        <v-col cols="9">
          <v-data-table
              :headers="headers"
              :items="tableData"
              :loading="loading"
              :items-per-page="$globalPageSize"
              :no-data-text="'没有更多数据了~'"
              hover
          >
            <template v-slot:loading>
              <v-skeleton-loader type="table-row@1"></v-skeleton-loader>
            </template>
  
            <template v-slot:item.goodsName="{item}">
              <el-link type="default" :underline="false" style="text-decoration: underline" :title="item.goodsName" @click="getDetail(item)">
                {{item.goodsName}}
              </el-link>
            </template>
  
            <template v-slot:item.time="{item}">
              {{ (item.startTime || item.endTime) ? (item.startTime + ' - ' + item.endTime) : ' - ' }}
            </template>
  
            <template v-slot:item.competitionState="{item}">
              <YTCompetitionState :state="item.competitionState"></YTCompetitionState>
            </template>
  
            <template v-slot:item.state="{item}">
              <el-text :type="item.state === 0 ? 'info' : 'success'" v-text="item.state === 0 ? '已撤销' : '已发布'"></el-text>
            </template>
  
            <template v-slot:item.controls="{ item }">
              <div class="flex_left">
                <el-popconfirm @confirm="setSale(item)" :title="`发布“${item.goodsName}”`">
                  <template #reference>
                    <div>
                      <el-tooltip
                          v-if="item.state === 0"
                          class="box-item"
                          effect="dark"
                          content="发布"
                          placement="left">
                        <v-icon class="cursor-pointer" icon="mdi-tray-arrow-up" color="success" v-show="$handleHasBtnPermission('all', 'competitionStoreGoodsState:edit')"></v-icon>
                      </el-tooltip>
                    </div>
                  </template>
                  <template #actions="{ confirm, cancel }">
                    <div class="flex_bt">
                      <v-btn size="small" @click="cancel">取消</v-btn>
                      <v-btn size="small" color="primary" @click="confirm">确定</v-btn>
                    </div>
                  </template>
                </el-popconfirm>
                <el-popconfirm @confirm="setUnSale(item)" :title="`撤销“${item.goodsName}”`">
                  <template #reference>
                    <div>
                      <el-tooltip
                          v-if="item.state === 1"
                          class="box-item"
                          effect="dark"
                          content="撤销"
                          placement="left">
                        <v-icon class="cursor-pointer" icon="mdi-tray-arrow-down" color="error"></v-icon>
                      </el-tooltip>
                    </div>
                  </template>
                  <template #actions="{ confirm, cancel }">
                    <div class="flex_bt">
                      <v-btn size="small" @click="cancel">取消</v-btn>
                      <v-btn size="small" color="primary" @click="confirm">确定</v-btn>
                    </div>
                  </template>
                </el-popconfirm>
                <el-tooltip
                    class="box-item"
                    effect="dark"
                    content="周边订单"
                    placement="top">
                  <v-icon class="cursor-pointer" style="margin-left: 10px;" icon="mdi-form-select" color="primary" @click="toSurroundingOrder(item)"></v-icon>
                </el-tooltip>
              </div>
            </template>
  
            <template v-slot:bottom>
              <YTTablePagination ref="YTTablePaginationRef" :total="total" @page-change="handleChangePage"></YTTablePagination>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </div>
  </template>
  <template v-else>
    <el-form-item label="赛事名称：">
      <div style="display: flex; gap: 20px;">
        <span>{{detailCache.goodsName}}</span>
        <v-btn class="mg_r_2" :disabled="false" @click="handleBack">返回</v-btn>
      </div>
    </el-form-item>
    <el-form-item label="赛事时间：">
      {{ (detailCache.startTime || detailCache.endTime) ? (detailCache.startTime + ' - ' + detailCache.endTime) : ' - ' }}
    </el-form-item>
    <el-form-item label="赛事城市：">
      {{detailCache.city}}
    </el-form-item>
    <el-form-item label="已报名人数：">
      {{detailCache.registeredCount}}
    </el-form-item>
    <el-form-item label="赛事状态：">
      <el-select v-model="competitionState" placeholder="Select" style="width: 240px" @change="handleChangeState">
        <el-option
            v-for="item in competitionStateOption"
            :key="item.stateId"
            :label="item.stateName"
            :value="item.stateId"
        />
      </el-select>
    </el-form-item>
    <el-divider></el-divider>
    <el-form-item>
      <v-tabs
          class="mg_r_3"
          v-model="tab"
          color="primary"
          @update:modelValue="handleTabChange"
      >
        <v-tab value="signedUp">报名人员</v-tab>
        <v-tab value="orderInfo">配套服务订单信息</v-tab>
      </v-tabs>
      <template v-if="tab === 'signedUp'">
        <v-btn class="mg_r_2" color="success" :disabled="false" @click="handleDownloadCompetitionUser(detailCache)">下载</v-btn>
      </template>
      <template v-else>
        <v-btn class="mg_r_2" color="success" :disabled="false" @click="handleDownloadCompetitionOrder(detailCache)">下载</v-btn>
      </template>
    </el-form-item>
    <el-form-item v-if="tab === 'orderInfo'" label="支付时间：" prop="paytime" style="width: 500px;">
      <el-date-picker
        v-model="detailPayTime"
        type="datetimerange"
        range-separator="至"
        start-placeholder="开始时间"
        end-placeholder="结束时间"
        value-format="YYYY-MM-DD HH:mm:ss"
        @change="handleChangeDetailPayTime"
      />
    </el-form-item>
    <div>
      <template v-if="tab === 'signedUp'">
        <el-table
          :data="detailTableData"
          :loading="detailTableLoading"
          style="width: 100%"
          stripe
        >
          <el-table-column type="index" label="序号" width="120" />
          <el-table-column prop="orderNo" label="订单编号" width="180" />
          <el-table-column prop="competitionPersonInfo.name" label="姓名" />
          <el-table-column prop="competitionPersonInfo.gender" label="性别">
            <template #default="scope">
              {{
                genderEnum.find(
                  (i) => i.stateId === scope.row.competitionPersonInfo.gender
                )?.stateName
              }}
            </template>
          </el-table-column>
          <el-table-column prop="competitionPersonInfo.birthDate" label="出生年月" min-width="180" />
          <el-table-column prop="competitionPersonInfo.nationality" label="国籍" />
          <el-table-column prop="competitionPersonInfo.certificateType" label="证件类型" min-width="120">
            <template #default="scope">
              {{
                certificateType.find(
                  (i) => i.stateId === scope.row.competitionPersonInfo.certificateType
                )
                  ? certificateType.find(
                      (i) => i.stateId === scope.row.competitionPersonInfo.certificateType
                    ).stateName
                  : "—"
              }}
            </template>
          </el-table-column>
          <el-table-column prop="competitionPersonInfo.certificateNumber" label="证件号" min-width="200" />
          <el-table-column prop="competitionPersonInfo.phone" label="手机号" min-width="120" />
          <el-table-column prop="competitionDivisions.divisionName" label="组别" min-width="180">
            <template #default="scope">
              {{ scope.row.competitionDivisions.map(item => item.divisionName).join('、') }}
            </template>
          </el-table-column>
          <el-table-column prop="competitionPersonInfo.team" label="代表队伍" min-width="120" />
          <el-table-column prop="competitionPersonInfo.emergencyContactName" label="紧急联系人" min-width="150" />
          <el-table-column prop="competitionPersonInfo.emergencyContactPhone" label="紧急联系人电话" min-width="180" />
          <el-table-column prop="competitionPersonInfo.remark" label="备注" />
          <el-table-column prop="orderState" label="报名状态" fixed="right">
            <template #default="scope">
              <YTOrderState :state="scope.row.orderState"></YTOrderState>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <template v-if="tab === 'orderInfo'">
        <el-table
          :data="detailTableData"
          :loading="detailTableLoading"
          :span-method="detailObjectSpanMethod"
          style="width: 100%"
          stripe
        >
          <el-table-column prop="orderNo" label="订单编号" width="180" />
          <el-table-column prop="paymentTime" label="支付时间" min-width="180" />
          <el-table-column prop="userId" label="用户ID" min-width="180" />
          <el-table-column prop="competitionPersonInfo.name" label="姓名" min-width="180" />
          <el-table-column prop="competitionPersonInfo.gender" label="性别">
            <template #default="scope">
              {{
                genderEnum.find(
                  (i) =>
                    i.stateId === scope.row.competitionPersonInfo.gender
                )?.stateName
              }}
            </template>
          </el-table-column>
          <el-table-column prop="competitionPersonInfo.phone" label="手机号" min-width="120" />
          <el-table-column prop="competitionDivisions.divisionName" label="组别" min-width="200">
            <template #default="scope">
              {{ scope.row.competitionDivisions.map(item => item.divisionName).join('、') }}
            </template>
          </el-table-column>
          <el-table-column prop="goodsName" label="购买商品信息" min-width="180" />
          <el-table-column prop="isGift" label="是否赠送">
            <template #default="scope">
              <div>{{scope.row.isGift ? "是" : "否"}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="quantity" label="商品数量" min-width="150" />
          <el-table-column prop="properties.propertyName" label="商品规格" min-width="180">
            <template #default="scope">
              {{ scope.row.properties?.map(item => item.propertyName).join('、') }}
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="自定义信息" min-width="180" />
          <el-table-column prop="finalPrice" label="订单金额" min-width="120" />
          <el-table-column prop="orderItemComboState" label="支付状态" min-width="120">
            <template #default="scope">
              <YTOrderState :state="scope.row.orderItemComboState || ''"></YTOrderState>
            </template>
          </el-table-column>
          <el-table-column prop="competitionPersonInfo.receiverName" label="收货人" min-width="120" />
          <el-table-column prop="competitionPersonInfo.receiverPhone" label="收货电话" min-width="120" />
          <el-table-column prop="competitionPersonInfo.receiverAddress" label="收货地址" min-width="120" />
          <el-table-column prop="orderState" label="订单状态" fixed="right">
            <template #default="scope">
              {{ 
                scope.row.isPartialRefund ? "已完成（部分退款）" : "已完成"
              }}
            </template>
          </el-table-column>
        </el-table>
      </template>
    </div>
    <div class="pd_b_4" style="padding-right: 20px">
      <YTTablePagination
        ref="YTTablePaginationDetailRef"
        :pageSize="$globalPageSize"
        :total="totalDetail"
        @page-change="handleChangeDetailPage"
      ></YTTablePagination>
    </div>
  </template>
</template>

<style scoped>
::marker {
  content: none;
}
</style>
